<template>
  <div class="homepage">
      <Hero />
      <ServicesOverview/>
      <HowWeCanHelp />
      <HomepageAboutUs />
      <TestimonialsSection />
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue'
import HomepageAboutUs from '@/components/HomepageAboutUs.vue'
import HowWeCanHelp from '@/components/HowWeCanHelp.vue'
import ServicesOverview from '@/components/ServicesOverview.vue'
import TestimonialsSection from '@/components/TestimonialsSection.vue'

export default {
  name: 'home-page',
  components: {
    Hero,
    ServicesOverview,
    HomepageAboutUs,
    HowWeCanHelp,
    TestimonialsSection
  }
}
</script>
